import { FC, useCallback } from 'react';
import classNames from 'classnames';

import { PrimaryIconButton } from '@rikstv/shared-components';

import { PlayTriangleIcon } from '../../icons';

import styles from './Overlay.module.css';

interface Props {
  title: string;
  showOverlay: boolean;
  showPlayButton: boolean;
  onClick: () => void;
  isPlayerPlaying: boolean;
  showMinimalOverlay?: boolean;
}

export const Overlay: FC<Props> = ({
  onClick,
  showOverlay,
  showPlayButton,
  isPlayerPlaying,
  title,
  showMinimalOverlay = false,
}) => {
  const playButtonRef = useCallback((element: HTMLElement | null) => {
    if (element !== null) {
      element.focus();
    }
  }, []);
  return (
    <div
      onClick={onClick}
      role="none"
      className={classNames(
        styles.overlay,
        { [styles.overlayHidden]: !showOverlay && !showMinimalOverlay },
        { [styles.hideGradient]: showPlayButton },
        { [styles.minimalUiGradient]: showMinimalOverlay }
      )}>
      <div className={classNames(styles.horizontalGradient, { [styles.showVerticalGradient]: !isPlayerPlaying })} />
      {showPlayButton && (
        <>
          <PrimaryIconButton
            className={styles.playButton}
            title="Start avspilling"
            aria-label={`Spill av ${title}`}
            icon={() => <PlayTriangleIcon style={{ paddingLeft: '13%' }} />}
            iconClass={styles.innerPlayIcon}
            ref={playButtonRef}
          />
        </>
      )}
    </div>
  );
};
